var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "video_button" },
    [
      _c("primary-button", {
        attrs: { link: false, label: _vm.label, type: "video" },
        nativeOn: {
          click: function ($event) {
            return _vm.modalOpen.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          class: { open: _vm.isModalOpen == true },
          on: { click: _vm.modalClose },
        },
        [
          _vm.isModalOpen === true
            ? _c(
                "div",
                { staticClass: "iframe__container" },
                [
                  _c("close-button", {
                    staticClass: "close_image",
                    attrs: { type: "grey" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.modalClose.apply(null, arguments)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("iframe", {
                    staticClass: "responsive__iframe",
                    attrs: {
                      src: _vm.video_source + _vm.setAutoplay,
                      frameborder: "0",
                      allow:
                        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }